package api

@Suppress("ClassName")
sealed class AppBehavior(val mask: Int) {
    object CAMPAIGN_OVERLAP : AppBehavior(2)
    object REDUCE_IMPRESSIONS : AppBehavior(4)

    infix fun match(type: Int): Boolean = this.mask and type > 0

    companion object {
        val all by lazy {
            listOf(
                CAMPAIGN_OVERLAP,
                REDUCE_IMPRESSIONS
            )
        }

        operator fun get(type: Int): AppBehavior {
            return all.firstOrNull {
                it.mask == type
            } ?: CAMPAIGN_OVERLAP
        }
    }

}